/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCompany = /* GraphQL */ `
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      IPCorp
      active
      updatedAt
      createdAt
      owner
      accounts {
        items {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      hq {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      IPCorp
      active
      updatedAt
      createdAt
      owner
      accounts {
        items {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      hq {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany($input: DeleteCompanyInput!) {
    deleteCompany(input: $input) {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      IPCorp
      active
      updatedAt
      createdAt
      owner
      accounts {
        items {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      hq {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const createAccount = /* GraphQL */ `
  mutation CreateAccount($input: CreateAccountInput!) {
    createAccount(input: $input) {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert
      IPCorp
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      owner
      updatedAt
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert
      IPCorp
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      owner
      updatedAt
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount($input: DeleteAccountInput!) {
    deleteAccount(input: $input) {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert
      IPCorp
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      owner
      updatedAt
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createService = /* GraphQL */ `
  mutation CreateService($input: CreateServiceInput!) {
    createService(input: $input) {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      updatedAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alertMessage
      ownershipType
      avgTrxAmount
      totalCashCreditSalesMonthly
      estAvgMcVisaTicketSaleAmount
      volumeMcVisaOutletMonthly
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      busSicCode
      busSicCodeDesc
      busProductsSold
      busSalesLimitM
      busTicketAvg
      busTicketMax
      busSwipePct
      busKeyPct
      busWebPct
      busMailPct
      busAgeY
      busAgeM
      busBusToBus
      busBusToCon
      busLocationCnt
      busSeasonOn
      busSeasonM
      busSeasonOpenM
      busSeasonCloseM
      amex
      amexNum
      discover
      discoverNum
      wexVoyagerOn
      wexVoyagerId
      esaId
      ebtFnsNum
      ebtCashOn
      checkServiceVendor
      checkServiceNum
      giftVendor
      giftVendorNum
      debitPinOn
      cashCreditSalesM
      mcVisaSaleAvg
      mcVisaVolM
      checksCntAvgM
      owner
      closeRequested
      closeDate
      closeReason
      closeReasonDetails
      closeEtfAmountRes
      closeCancelFee
      closeResReportDate
      closeEtfAmount
      closeEtfAdjust
      closeEtfRefundAmount
      closeEtfRefundDate
      closeEtfChargedDate
      closeEtfWaiveReason
      closeEtfWaiveOther
      closeResReportRefundDate
      beta
      pendingResponsibility
      dateSubmitted
      dateFirstProcessing
      declineReason
      declineNotes
      annualAmount
      annualAmountPCI
      altMonthMinAmount
      isWithdrawalAccount
      wbankName
      wbankRouting
      wbankAccount
      withdrawalAccount
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      portfolios {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      closeEtfWaiveAppover {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const updateService = /* GraphQL */ `
  mutation UpdateService($input: UpdateServiceInput!) {
    updateService(input: $input) {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      updatedAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alertMessage
      ownershipType
      avgTrxAmount
      totalCashCreditSalesMonthly
      estAvgMcVisaTicketSaleAmount
      volumeMcVisaOutletMonthly
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      busSicCode
      busSicCodeDesc
      busProductsSold
      busSalesLimitM
      busTicketAvg
      busTicketMax
      busSwipePct
      busKeyPct
      busWebPct
      busMailPct
      busAgeY
      busAgeM
      busBusToBus
      busBusToCon
      busLocationCnt
      busSeasonOn
      busSeasonM
      busSeasonOpenM
      busSeasonCloseM
      amex
      amexNum
      discover
      discoverNum
      wexVoyagerOn
      wexVoyagerId
      esaId
      ebtFnsNum
      ebtCashOn
      checkServiceVendor
      checkServiceNum
      giftVendor
      giftVendorNum
      debitPinOn
      cashCreditSalesM
      mcVisaSaleAvg
      mcVisaVolM
      checksCntAvgM
      owner
      closeRequested
      closeDate
      closeReason
      closeReasonDetails
      closeEtfAmountRes
      closeCancelFee
      closeResReportDate
      closeEtfAmount
      closeEtfAdjust
      closeEtfRefundAmount
      closeEtfRefundDate
      closeEtfChargedDate
      closeEtfWaiveReason
      closeEtfWaiveOther
      closeResReportRefundDate
      beta
      pendingResponsibility
      dateSubmitted
      dateFirstProcessing
      declineReason
      declineNotes
      annualAmount
      annualAmountPCI
      altMonthMinAmount
      isWithdrawalAccount
      wbankName
      wbankRouting
      wbankAccount
      withdrawalAccount
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      portfolios {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      closeEtfWaiveAppover {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const deleteService = /* GraphQL */ `
  mutation DeleteService($input: DeleteServiceInput!) {
    deleteService(input: $input) {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      updatedAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alertMessage
      ownershipType
      avgTrxAmount
      totalCashCreditSalesMonthly
      estAvgMcVisaTicketSaleAmount
      volumeMcVisaOutletMonthly
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      busSicCode
      busSicCodeDesc
      busProductsSold
      busSalesLimitM
      busTicketAvg
      busTicketMax
      busSwipePct
      busKeyPct
      busWebPct
      busMailPct
      busAgeY
      busAgeM
      busBusToBus
      busBusToCon
      busLocationCnt
      busSeasonOn
      busSeasonM
      busSeasonOpenM
      busSeasonCloseM
      amex
      amexNum
      discover
      discoverNum
      wexVoyagerOn
      wexVoyagerId
      esaId
      ebtFnsNum
      ebtCashOn
      checkServiceVendor
      checkServiceNum
      giftVendor
      giftVendorNum
      debitPinOn
      cashCreditSalesM
      mcVisaSaleAvg
      mcVisaVolM
      checksCntAvgM
      owner
      closeRequested
      closeDate
      closeReason
      closeReasonDetails
      closeEtfAmountRes
      closeCancelFee
      closeResReportDate
      closeEtfAmount
      closeEtfAdjust
      closeEtfRefundAmount
      closeEtfRefundDate
      closeEtfChargedDate
      closeEtfWaiveReason
      closeEtfWaiveOther
      closeResReportRefundDate
      beta
      pendingResponsibility
      dateSubmitted
      dateFirstProcessing
      declineReason
      declineNotes
      annualAmount
      annualAmountPCI
      altMonthMinAmount
      isWithdrawalAccount
      wbankName
      wbankRouting
      wbankAccount
      withdrawalAccount
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      portfolios {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      closeEtfWaiveAppover {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const createPortfolio = /* GraphQL */ `
  mutation CreatePortfolio($input: CreatePortfolioInput!) {
    createPortfolio(input: $input) {
      id
      name
      description
      premier
      status
      owner
      createdAt
      updatedAt
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      reportPortfolios {
        items {
          id
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updatePortfolio = /* GraphQL */ `
  mutation UpdatePortfolio($input: UpdatePortfolioInput!) {
    updatePortfolio(input: $input) {
      id
      name
      description
      premier
      status
      owner
      createdAt
      updatedAt
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      reportPortfolios {
        items {
          id
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deletePortfolio = /* GraphQL */ `
  mutation DeletePortfolio($input: DeletePortfolioInput!) {
    deletePortfolio(input: $input) {
      id
      name
      description
      premier
      status
      owner
      createdAt
      updatedAt
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      reportPortfolios {
        items {
          id
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createPortfolioService = /* GraphQL */ `
  mutation CreatePortfolioService($input: CreatePortfolioServiceInput!) {
    createPortfolioService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const updatePortfolioService = /* GraphQL */ `
  mutation UpdatePortfolioService($input: UpdatePortfolioServiceInput!) {
    updatePortfolioService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const deletePortfolioService = /* GraphQL */ `
  mutation DeletePortfolioService($input: DeletePortfolioServiceInput!) {
    deletePortfolioService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const createReportPortfolios = /* GraphQL */ `
  mutation CreateReportPortfolios($input: CreateReportPortfoliosInput!) {
    createReportPortfolios(input: $input) {
      id
      createdAt
      updatedAt
      owner
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateReportPortfolios = /* GraphQL */ `
  mutation UpdateReportPortfolios($input: UpdateReportPortfoliosInput!) {
    updateReportPortfolios(input: $input) {
      id
      createdAt
      updatedAt
      owner
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteReportPortfolios = /* GraphQL */ `
  mutation DeleteReportPortfolios($input: DeleteReportPortfoliosInput!) {
    deleteReportPortfolios(input: $input) {
      id
      createdAt
      updatedAt
      owner
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      name
      description
      status
      billingMethod
      serial
      platform
      appType
      connect
      conversion
      encryptionKey
      purchaseSwap
      feeMonthly
      cashDiscount
      owner
      virtualTerminal
      accountVault
      recurring
      customerSignUp
      authNetEmulator
      multMerchantMultiDeposit
      multiMerchantNumber
      notesComments
      setupFee
      perItemFee
      feeMonthlyAmount
      terminalOrTsysId
      midV
      storeNumber
      url
      usernames
      gatewayId
      vendorContactNotes
      conversionSetupCost
      soldAmount
      warrantyReplacement
      replacementDate
      isPinPad
      pinPadPurchaseAmount
      FPPPinMonthlyFee
      pabx
      staticIp
      dns1
      gatewayIp
      subnet
      dns2
      secureFileCheck
      securityLevel
      tipLine
      counterTip
      serverNumer
      autoCloseTime
      giftCardProvider
      ebt
      avs
      checkProviderNumber
      fraud
      merchantNumber
      purchaseCard
      taxId
      downloadPhone
      portNumber
      deviceId
      emvSmartCard
      nfc
      autoClose
      giftCards
      internalPinPad
      checkServices
      cvv2
      multiMerchant
      invoiceNumber
      customerCode
      createdAt
      updatedAt
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      billToService {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      productOption {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      name
      description
      status
      billingMethod
      serial
      platform
      appType
      connect
      conversion
      encryptionKey
      purchaseSwap
      feeMonthly
      cashDiscount
      owner
      virtualTerminal
      accountVault
      recurring
      customerSignUp
      authNetEmulator
      multMerchantMultiDeposit
      multiMerchantNumber
      notesComments
      setupFee
      perItemFee
      feeMonthlyAmount
      terminalOrTsysId
      midV
      storeNumber
      url
      usernames
      gatewayId
      vendorContactNotes
      conversionSetupCost
      soldAmount
      warrantyReplacement
      replacementDate
      isPinPad
      pinPadPurchaseAmount
      FPPPinMonthlyFee
      pabx
      staticIp
      dns1
      gatewayIp
      subnet
      dns2
      secureFileCheck
      securityLevel
      tipLine
      counterTip
      serverNumer
      autoCloseTime
      giftCardProvider
      ebt
      avs
      checkProviderNumber
      fraud
      merchantNumber
      purchaseCard
      taxId
      downloadPhone
      portNumber
      deviceId
      emvSmartCard
      nfc
      autoClose
      giftCards
      internalPinPad
      checkServices
      cvv2
      multiMerchant
      invoiceNumber
      customerCode
      createdAt
      updatedAt
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      billToService {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      productOption {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct($input: DeleteProductInput!) {
    deleteProduct(input: $input) {
      id
      name
      description
      status
      billingMethod
      serial
      platform
      appType
      connect
      conversion
      encryptionKey
      purchaseSwap
      feeMonthly
      cashDiscount
      owner
      virtualTerminal
      accountVault
      recurring
      customerSignUp
      authNetEmulator
      multMerchantMultiDeposit
      multiMerchantNumber
      notesComments
      setupFee
      perItemFee
      feeMonthlyAmount
      terminalOrTsysId
      midV
      storeNumber
      url
      usernames
      gatewayId
      vendorContactNotes
      conversionSetupCost
      soldAmount
      warrantyReplacement
      replacementDate
      isPinPad
      pinPadPurchaseAmount
      FPPPinMonthlyFee
      pabx
      staticIp
      dns1
      gatewayIp
      subnet
      dns2
      secureFileCheck
      securityLevel
      tipLine
      counterTip
      serverNumer
      autoCloseTime
      giftCardProvider
      ebt
      avs
      checkProviderNumber
      fraud
      merchantNumber
      purchaseCard
      taxId
      downloadPhone
      portNumber
      deviceId
      emvSmartCard
      nfc
      autoClose
      giftCards
      internalPinPad
      checkServices
      cvv2
      multiMerchant
      invoiceNumber
      customerCode
      createdAt
      updatedAt
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      billToService {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      productOption {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createProductChild = /* GraphQL */ `
  mutation CreateProductChild($input: CreateProductChildInput!) {
    createProductChild(input: $input) {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const updateProductChild = /* GraphQL */ `
  mutation UpdateProductChild($input: UpdateProductChildInput!) {
    updateProductChild(input: $input) {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const deleteProductChild = /* GraphQL */ `
  mutation DeleteProductChild($input: DeleteProductChildInput!) {
    deleteProductChild(input: $input) {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const createProductService = /* GraphQL */ `
  mutation CreateProductService($input: CreateProductServiceInput!) {
    createProductService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const updateProductService = /* GraphQL */ `
  mutation UpdateProductService($input: UpdateProductServiceInput!) {
    updateProductService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const deleteProductService = /* GraphQL */ `
  mutation DeleteProductService($input: DeleteProductServiceInput!) {
    deleteProductService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const createProductOption = /* GraphQL */ `
  mutation CreateProductOption($input: CreateProductOptionInput!) {
    createProductOption(input: $input) {
      id
      name
      category
      brand
      legacyName
      status
      notes
      owner
      createdAt
      updatedAt
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateProductOption = /* GraphQL */ `
  mutation UpdateProductOption($input: UpdateProductOptionInput!) {
    updateProductOption(input: $input) {
      id
      name
      category
      brand
      legacyName
      status
      notes
      owner
      createdAt
      updatedAt
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteProductOption = /* GraphQL */ `
  mutation DeleteProductOption($input: DeleteProductOptionInput!) {
    deleteProductOption(input: $input) {
      id
      name
      category
      brand
      legacyName
      status
      notes
      owner
      createdAt
      updatedAt
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createProductOptionChild = /* GraphQL */ `
  mutation CreateProductOptionChild($input: CreateProductOptionChildInput!) {
    createProductOptionChild(input: $input) {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const updateProductOptionChild = /* GraphQL */ `
  mutation UpdateProductOptionChild($input: UpdateProductOptionChildInput!) {
    updateProductOptionChild(input: $input) {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const deleteProductOptionChild = /* GraphQL */ `
  mutation DeleteProductOptionChild($input: DeleteProductOptionChildInput!) {
    deleteProductOptionChild(input: $input) {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const createPerson = /* GraphQL */ `
  mutation CreatePerson($input: CreatePersonInput!) {
    createPerson(input: $input) {
      id
      given_name
      middle_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number_verified
      phone_mobile
      phone_number
      phone_other
      phone_home
      fax_number
      addressHome
      addressOther
      ssn
      dob
      dl_number
      createdAt
      updatedAt
      description
      premier
      cognito_userid
      owner
      companys {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      accounts {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const updatePerson = /* GraphQL */ `
  mutation UpdatePerson($input: UpdatePersonInput!) {
    updatePerson(input: $input) {
      id
      given_name
      middle_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number_verified
      phone_mobile
      phone_number
      phone_other
      phone_home
      fax_number
      addressHome
      addressOther
      ssn
      dob
      dl_number
      createdAt
      updatedAt
      description
      premier
      cognito_userid
      owner
      companys {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      accounts {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const deletePerson = /* GraphQL */ `
  mutation DeletePerson($input: DeletePersonInput!) {
    deletePerson(input: $input) {
      id
      given_name
      middle_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number_verified
      phone_mobile
      phone_number
      phone_other
      phone_home
      fax_number
      addressHome
      addressOther
      ssn
      dob
      dl_number
      createdAt
      updatedAt
      description
      premier
      cognito_userid
      owner
      companys {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      accounts {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const createSalesRep = /* GraphQL */ `
  mutation CreateSalesRep($input: CreateSalesRepInput!) {
    createSalesRep(input: $input) {
      id
      given_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number
      phone_number_verified
      addressMailing
      description
      premier
      cognito_userid
      createdAt
      updatedAt
      owner
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateSalesRep = /* GraphQL */ `
  mutation UpdateSalesRep($input: UpdateSalesRepInput!) {
    updateSalesRep(input: $input) {
      id
      given_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number
      phone_number_verified
      addressMailing
      description
      premier
      cognito_userid
      createdAt
      updatedAt
      owner
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteSalesRep = /* GraphQL */ `
  mutation DeleteSalesRep($input: DeleteSalesRepInput!) {
    deleteSalesRep(input: $input) {
      id
      given_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number
      phone_number_verified
      addressMailing
      description
      premier
      cognito_userid
      createdAt
      updatedAt
      owner
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createPersonCompany = /* GraphQL */ `
  mutation CreatePersonCompany($input: CreatePersonCompanyInput!) {
    createPersonCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const updatePersonCompany = /* GraphQL */ `
  mutation UpdatePersonCompany($input: UpdatePersonCompanyInput!) {
    updatePersonCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const deletePersonCompany = /* GraphQL */ `
  mutation DeletePersonCompany($input: DeletePersonCompanyInput!) {
    deletePersonCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const createPersonAccount = /* GraphQL */ `
  mutation CreatePersonAccount($input: CreatePersonAccountInput!) {
    createPersonAccount(input: $input) {
      id
      role
      title
      email
      business_email
      other_email
      ownership
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const updatePersonAccount = /* GraphQL */ `
  mutation UpdatePersonAccount($input: UpdatePersonAccountInput!) {
    updatePersonAccount(input: $input) {
      id
      role
      title
      email
      business_email
      other_email
      ownership
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const deletePersonAccount = /* GraphQL */ `
  mutation DeletePersonAccount($input: DeletePersonAccountInput!) {
    deletePersonAccount(input: $input) {
      id
      role
      title
      email
      business_email
      other_email
      ownership
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const createCaseAccount = /* GraphQL */ `
  mutation CreateCaseAccount($input: CreateCaseAccountInput!) {
    createCaseAccount(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const updateCaseAccount = /* GraphQL */ `
  mutation UpdateCaseAccount($input: UpdateCaseAccountInput!) {
    updateCaseAccount(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const deleteCaseAccount = /* GraphQL */ `
  mutation DeleteCaseAccount($input: DeleteCaseAccountInput!) {
    deleteCaseAccount(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const createCaseService = /* GraphQL */ `
  mutation CreateCaseService($input: CreateCaseServiceInput!) {
    createCaseService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const updateCaseService = /* GraphQL */ `
  mutation UpdateCaseService($input: UpdateCaseServiceInput!) {
    updateCaseService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const deleteCaseService = /* GraphQL */ `
  mutation DeleteCaseService($input: DeleteCaseServiceInput!) {
    deleteCaseService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const createCaseProduct = /* GraphQL */ `
  mutation CreateCaseProduct($input: CreateCaseProductInput!) {
    createCaseProduct(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const updateCaseProduct = /* GraphQL */ `
  mutation UpdateCaseProduct($input: UpdateCaseProductInput!) {
    updateCaseProduct(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const deleteCaseProduct = /* GraphQL */ `
  mutation DeleteCaseProduct($input: DeleteCaseProductInput!) {
    deleteCaseProduct(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const createCaseCompany = /* GraphQL */ `
  mutation CreateCaseCompany($input: CreateCaseCompanyInput!) {
    createCaseCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const updateCaseCompany = /* GraphQL */ `
  mutation UpdateCaseCompany($input: UpdateCaseCompanyInput!) {
    updateCaseCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const deleteCaseCompany = /* GraphQL */ `
  mutation DeleteCaseCompany($input: DeleteCaseCompanyInput!) {
    deleteCaseCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const createCaseSalesRep = /* GraphQL */ `
  mutation CreateCaseSalesRep($input: CreateCaseSalesRepInput!) {
    createCaseSalesRep(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const updateCaseSalesRep = /* GraphQL */ `
  mutation UpdateCaseSalesRep($input: UpdateCaseSalesRepInput!) {
    updateCaseSalesRep(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const deleteCaseSalesRep = /* GraphQL */ `
  mutation DeleteCaseSalesRep($input: DeleteCaseSalesRepInput!) {
    deleteCaseSalesRep(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const createTaskAccount = /* GraphQL */ `
  mutation CreateTaskAccount($input: CreateTaskAccountInput!) {
    createTaskAccount(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const updateTaskAccount = /* GraphQL */ `
  mutation UpdateTaskAccount($input: UpdateTaskAccountInput!) {
    updateTaskAccount(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const deleteTaskAccount = /* GraphQL */ `
  mutation DeleteTaskAccount($input: DeleteTaskAccountInput!) {
    deleteTaskAccount(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const createTaskService = /* GraphQL */ `
  mutation CreateTaskService($input: CreateTaskServiceInput!) {
    createTaskService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const updateTaskService = /* GraphQL */ `
  mutation UpdateTaskService($input: UpdateTaskServiceInput!) {
    updateTaskService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const deleteTaskService = /* GraphQL */ `
  mutation DeleteTaskService($input: DeleteTaskServiceInput!) {
    deleteTaskService(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const createTaskProduct = /* GraphQL */ `
  mutation CreateTaskProduct($input: CreateTaskProductInput!) {
    createTaskProduct(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const updateTaskProduct = /* GraphQL */ `
  mutation UpdateTaskProduct($input: UpdateTaskProductInput!) {
    updateTaskProduct(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const deleteTaskProduct = /* GraphQL */ `
  mutation DeleteTaskProduct($input: DeleteTaskProductInput!) {
    deleteTaskProduct(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const createTaskCompany = /* GraphQL */ `
  mutation CreateTaskCompany($input: CreateTaskCompanyInput!) {
    createTaskCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const updateTaskCompany = /* GraphQL */ `
  mutation UpdateTaskCompany($input: UpdateTaskCompanyInput!) {
    updateTaskCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const deleteTaskCompany = /* GraphQL */ `
  mutation DeleteTaskCompany($input: DeleteTaskCompanyInput!) {
    deleteTaskCompany(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const createTaskSalesRep = /* GraphQL */ `
  mutation CreateTaskSalesRep($input: CreateTaskSalesRepInput!) {
    createTaskSalesRep(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const updateTaskSalesRep = /* GraphQL */ `
  mutation UpdateTaskSalesRep($input: UpdateTaskSalesRepInput!) {
    updateTaskSalesRep(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const deleteTaskSalesRep = /* GraphQL */ `
  mutation DeleteTaskSalesRep($input: DeleteTaskSalesRepInput!) {
    deleteTaskSalesRep(input: $input) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const createCase = /* GraphQL */ `
  mutation CreateCase($input: CreateCaseInput!) {
    createCase(input: $input) {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      alertMessage
      dateDue
      closedDate
      priority
      quickNote
      createdAt
      updatedAt
      owner
      rushReason
      isSystemCreated
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      template {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      caseLinks {
        items {
          id
          reason
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const updateCase = /* GraphQL */ `
  mutation UpdateCase($input: UpdateCaseInput!) {
    updateCase(input: $input) {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      alertMessage
      dateDue
      closedDate
      priority
      quickNote
      createdAt
      updatedAt
      owner
      rushReason
      isSystemCreated
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      template {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      caseLinks {
        items {
          id
          reason
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const deleteCase = /* GraphQL */ `
  mutation DeleteCase($input: DeleteCaseInput!) {
    deleteCase(input: $input) {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      alertMessage
      dateDue
      closedDate
      priority
      quickNote
      createdAt
      updatedAt
      owner
      rushReason
      isSystemCreated
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      template {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      caseLinks {
        items {
          id
          reason
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const createAttachment = /* GraphQL */ `
  mutation CreateAttachment($input: CreateAttachmentInput!) {
    createAttachment(input: $input) {
      id
      name
      type
      description
      s3Path
      isDeleted
      internal
      owner
      createdAt
      updatedAt
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateAttachment = /* GraphQL */ `
  mutation UpdateAttachment($input: UpdateAttachmentInput!) {
    updateAttachment(input: $input) {
      id
      name
      type
      description
      s3Path
      isDeleted
      internal
      owner
      createdAt
      updatedAt
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteAttachment = /* GraphQL */ `
  mutation DeleteAttachment($input: DeleteAttachmentInput!) {
    deleteAttachment(input: $input) {
      id
      name
      type
      description
      s3Path
      isDeleted
      internal
      owner
      createdAt
      updatedAt
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createRelation = /* GraphQL */ `
  mutation CreateRelation($input: CreateRelationInput!) {
    createRelation(input: $input) {
      id
      fromModelType
      toModelType
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      attachment {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      comment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const updateRelation = /* GraphQL */ `
  mutation UpdateRelation($input: UpdateRelationInput!) {
    updateRelation(input: $input) {
      id
      fromModelType
      toModelType
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      attachment {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      comment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const deleteRelation = /* GraphQL */ `
  mutation DeleteRelation($input: DeleteRelationInput!) {
    deleteRelation(input: $input) {
      id
      fromModelType
      toModelType
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      attachment {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      comment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const createCaseTemplate = /* GraphQL */ `
  mutation CreateCaseTemplate($input: CreateCaseTemplateInput!) {
    createCaseTemplate(input: $input) {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      dateDue
      priority
      createdAt
      updatedAt
      owner
      hasWorkflow
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
    }
  }
`;
export const updateCaseTemplate = /* GraphQL */ `
  mutation UpdateCaseTemplate($input: UpdateCaseTemplateInput!) {
    updateCaseTemplate(input: $input) {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      dateDue
      priority
      createdAt
      updatedAt
      owner
      hasWorkflow
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
    }
  }
`;
export const deleteCaseTemplate = /* GraphQL */ `
  mutation DeleteCaseTemplate($input: DeleteCaseTemplateInput!) {
    deleteCaseTemplate(input: $input) {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      dateDue
      priority
      createdAt
      updatedAt
      owner
      hasWorkflow
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
    }
  }
`;
export const createCaseTemplateTask = /* GraphQL */ `
  mutation CreateCaseTemplateTask($input: CreateCaseTemplateTaskInput!) {
    createCaseTemplateTask(input: $input) {
      id
      order
      type
      dateDue
      subject
      internal
      createdAt
      updatedAt
      owner
      priority
      status
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateCaseTemplateTask = /* GraphQL */ `
  mutation UpdateCaseTemplateTask($input: UpdateCaseTemplateTaskInput!) {
    updateCaseTemplateTask(input: $input) {
      id
      order
      type
      dateDue
      subject
      internal
      createdAt
      updatedAt
      owner
      priority
      status
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteCaseTemplateTask = /* GraphQL */ `
  mutation DeleteCaseTemplateTask($input: DeleteCaseTemplateTaskInput!) {
    deleteCaseTemplateTask(input: $input) {
      id
      order
      type
      dateDue
      subject
      internal
      createdAt
      updatedAt
      owner
      priority
      status
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createCaseLink = /* GraphQL */ `
  mutation CreateCaseLink($input: CreateCaseLinkInput!) {
    createCaseLink(input: $input) {
      id
      reason
      owner
      createdAt
      updatedAt
      esData
      esSync
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      linkCase {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const updateCaseLink = /* GraphQL */ `
  mutation UpdateCaseLink($input: UpdateCaseLinkInput!) {
    updateCaseLink(input: $input) {
      id
      reason
      owner
      createdAt
      updatedAt
      esData
      esSync
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      linkCase {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const deleteCaseLink = /* GraphQL */ `
  mutation DeleteCaseLink($input: DeleteCaseLinkInput!) {
    deleteCaseLink(input: $input) {
      id
      reason
      owner
      createdAt
      updatedAt
      esData
      esSync
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      linkCase {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      source
      IPCorp
      internal
      TaskSaveAsTemplate
      CaseSaveAsTemplate
      createdAt
      updatedAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      cogUserCreateDate
      cogUserLastModifiedDate
      cogEnabled
      cogUserStatus
      cogEmailVerified
      cogMFAOptions {
        DeliveryMedium
        AttributeName
      }
      cogPreferredMfaSetting
      cogUserMFASettingList
      owner
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      teams {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
      changes {
        items {
          id
          owner
          createdAt
          updatedAt
          action
          modelId
          modelName
          change
        }
        nextToken
      }
      alerts {
        items {
          id
          owner
          createdAt
          updatedAt
          type
          subject
          body
          link
          ttl
          level
          status
        }
        nextToken
      }
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      source
      IPCorp
      internal
      TaskSaveAsTemplate
      CaseSaveAsTemplate
      createdAt
      updatedAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      cogUserCreateDate
      cogUserLastModifiedDate
      cogEnabled
      cogUserStatus
      cogEmailVerified
      cogMFAOptions {
        DeliveryMedium
        AttributeName
      }
      cogPreferredMfaSetting
      cogUserMFASettingList
      owner
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      teams {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
      changes {
        items {
          id
          owner
          createdAt
          updatedAt
          action
          modelId
          modelName
          change
        }
        nextToken
      }
      alerts {
        items {
          id
          owner
          createdAt
          updatedAt
          type
          subject
          body
          link
          ttl
          level
          status
        }
        nextToken
      }
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      source
      IPCorp
      internal
      TaskSaveAsTemplate
      CaseSaveAsTemplate
      createdAt
      updatedAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      cogUserCreateDate
      cogUserLastModifiedDate
      cogEnabled
      cogUserStatus
      cogEmailVerified
      cogMFAOptions {
        DeliveryMedium
        AttributeName
      }
      cogPreferredMfaSetting
      cogUserMFASettingList
      owner
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      teams {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
      changes {
        items {
          id
          owner
          createdAt
          updatedAt
          action
          modelId
          modelName
          change
        }
        nextToken
      }
      alerts {
        items {
          id
          owner
          createdAt
          updatedAt
          type
          subject
          body
          link
          ttl
          level
          status
        }
        nextToken
      }
    }
  }
`;
export const createHq = /* GraphQL */ `
  mutation CreateHq($input: CreateHQInput!) {
    createHQ(input: $input) {
      id
      name
      createdAt
      updatedAt
      owner
      IPCorp
      active
      companies {
        items {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateHq = /* GraphQL */ `
  mutation UpdateHq($input: UpdateHQInput!) {
    updateHQ(input: $input) {
      id
      name
      createdAt
      updatedAt
      owner
      IPCorp
      active
      companies {
        items {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteHq = /* GraphQL */ `
  mutation DeleteHq($input: DeleteHQInput!) {
    deleteHQ(input: $input) {
      id
      name
      createdAt
      updatedAt
      owner
      IPCorp
      active
      companies {
        items {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createSalesOffice = /* GraphQL */ `
  mutation CreateSalesOffice($input: CreateSalesOfficeInput!) {
    createSalesOffice(input: $input) {
      id
      name
      active
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateSalesOffice = /* GraphQL */ `
  mutation UpdateSalesOffice($input: UpdateSalesOfficeInput!) {
    updateSalesOffice(input: $input) {
      id
      name
      active
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteSalesOffice = /* GraphQL */ `
  mutation DeleteSalesOffice($input: DeleteSalesOfficeInput!) {
    deleteSalesOffice(input: $input) {
      id
      name
      active
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createTeam = /* GraphQL */ `
  mutation CreateTeam($input: CreateTeamInput!) {
    createTeam(input: $input) {
      id
      name
      cognito_groupid
      owner
      createdAt
      default
      updatedAt
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      users {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
    }
  }
`;
export const updateTeam = /* GraphQL */ `
  mutation UpdateTeam($input: UpdateTeamInput!) {
    updateTeam(input: $input) {
      id
      name
      cognito_groupid
      owner
      createdAt
      default
      updatedAt
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      users {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
    }
  }
`;
export const deleteTeam = /* GraphQL */ `
  mutation DeleteTeam($input: DeleteTeamInput!) {
    deleteTeam(input: $input) {
      id
      name
      cognito_groupid
      owner
      createdAt
      default
      updatedAt
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      users {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
    }
  }
`;
export const createTeamUser = /* GraphQL */ `
  mutation CreateTeamUser($input: CreateTeamUserInput!) {
    createTeamUser(input: $input) {
      id
      role
      cognito_userid
      cognito_groupid
      owner
      createdAt
      updatedAt
      esData
      esSync
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
    }
  }
`;
export const updateTeamUser = /* GraphQL */ `
  mutation UpdateTeamUser($input: UpdateTeamUserInput!) {
    updateTeamUser(input: $input) {
      id
      role
      cognito_userid
      cognito_groupid
      owner
      createdAt
      updatedAt
      esData
      esSync
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
    }
  }
`;
export const deleteTeamUser = /* GraphQL */ `
  mutation DeleteTeamUser($input: DeleteTeamUserInput!) {
    deleteTeamUser(input: $input) {
      id
      role
      cognito_userid
      cognito_groupid
      owner
      createdAt
      updatedAt
      esData
      esSync
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
    }
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      id
      isTemplate
      isAvailable
      isCompleteInOrder
      type
      dateDue
      subject
      internal
      owner
      group
      order
      createdAt
      updatedAt
      priority
      status
      dateCompleted
      quickNote
      isSystemCreated
      hasWorkflow
      skipAlert
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      caseTemplate {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      taskTemplate {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      steps {
        items {
          id
          title
          description
          isAvailable
          order
          status
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const updateTask = /* GraphQL */ `
  mutation UpdateTask($input: UpdateTaskInput!) {
    updateTask(input: $input) {
      id
      isTemplate
      isAvailable
      isCompleteInOrder
      type
      dateDue
      subject
      internal
      owner
      group
      order
      createdAt
      updatedAt
      priority
      status
      dateCompleted
      quickNote
      isSystemCreated
      hasWorkflow
      skipAlert
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      caseTemplate {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      taskTemplate {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      steps {
        items {
          id
          title
          description
          isAvailable
          order
          status
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask($input: DeleteTaskInput!) {
    deleteTask(input: $input) {
      id
      isTemplate
      isAvailable
      isCompleteInOrder
      type
      dateDue
      subject
      internal
      owner
      group
      order
      createdAt
      updatedAt
      priority
      status
      dateCompleted
      quickNote
      isSystemCreated
      hasWorkflow
      skipAlert
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      caseTemplate {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      taskTemplate {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      steps {
        items {
          id
          title
          description
          isAvailable
          order
          status
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const createTaskStep = /* GraphQL */ `
  mutation CreateTaskStep($input: CreateTaskStepInput!) {
    createTaskStep(input: $input) {
      id
      title
      description
      isAvailable
      order
      status
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const updateTaskStep = /* GraphQL */ `
  mutation UpdateTaskStep($input: UpdateTaskStepInput!) {
    updateTaskStep(input: $input) {
      id
      title
      description
      isAvailable
      order
      status
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const deleteTaskStep = /* GraphQL */ `
  mutation DeleteTaskStep($input: DeleteTaskStepInput!) {
    deleteTaskStep(input: $input) {
      id
      title
      description
      isAvailable
      order
      status
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      messageCaseId
      replyToMessageId
      outgoingFlag
      attachmentOptions
      messageAttachmentId
      bounces
      origin
      createdAt
      updatedAt
      owner
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage($input: UpdateMessageInput!) {
    updateMessage(input: $input) {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      messageCaseId
      replyToMessageId
      outgoingFlag
      attachmentOptions
      messageAttachmentId
      bounces
      origin
      createdAt
      updatedAt
      owner
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage($input: DeleteMessageInput!) {
    deleteMessage(input: $input) {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      messageCaseId
      replyToMessageId
      outgoingFlag
      attachmentOptions
      messageAttachmentId
      bounces
      origin
      createdAt
      updatedAt
      owner
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const createCaseDraft = /* GraphQL */ `
  mutation CreateCaseDraft($input: CreateCaseDraftInput!) {
    createCaseDraft(input: $input) {
      id
      subject
      from
      to
      cc
      bcc
      body
      messageCaseId
      internal
      owner
      draftType
      replyToMessageId
      createdAt
      updatedAt
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateCaseDraft = /* GraphQL */ `
  mutation UpdateCaseDraft($input: UpdateCaseDraftInput!) {
    updateCaseDraft(input: $input) {
      id
      subject
      from
      to
      cc
      bcc
      body
      messageCaseId
      internal
      owner
      draftType
      replyToMessageId
      createdAt
      updatedAt
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteCaseDraft = /* GraphQL */ `
  mutation DeleteCaseDraft($input: DeleteCaseDraftInput!) {
    deleteCaseDraft(input: $input) {
      id
      subject
      from
      to
      cc
      bcc
      body
      messageCaseId
      internal
      owner
      draftType
      replyToMessageId
      createdAt
      updatedAt
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createMessageOutgoing = /* GraphQL */ `
  mutation CreateMessageOutgoing($input: CreateMessageOutgoingInput!) {
    createMessageOutgoing(input: $input) {
      id
      replyToMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      attachmentOptions
      messageCaseId
      messageUserId
      outgoingFlag
      messageAttachmentId
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateMessageOutgoing = /* GraphQL */ `
  mutation UpdateMessageOutgoing($input: UpdateMessageOutgoingInput!) {
    updateMessageOutgoing(input: $input) {
      id
      replyToMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      attachmentOptions
      messageCaseId
      messageUserId
      outgoingFlag
      messageAttachmentId
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteMessageOutgoing = /* GraphQL */ `
  mutation DeleteMessageOutgoing($input: DeleteMessageOutgoingInput!) {
    deleteMessageOutgoing(input: $input) {
      id
      replyToMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      attachmentOptions
      messageCaseId
      messageUserId
      outgoingFlag
      messageAttachmentId
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createMessageAttachment = /* GraphQL */ `
  mutation CreateMessageAttachment($input: CreateMessageAttachmentInput!) {
    createMessageAttachment(input: $input) {
      id
      messageId
      attachmentId
      internal
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateMessageAttachment = /* GraphQL */ `
  mutation UpdateMessageAttachment($input: UpdateMessageAttachmentInput!) {
    updateMessageAttachment(input: $input) {
      id
      messageId
      attachmentId
      internal
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteMessageAttachment = /* GraphQL */ `
  mutation DeleteMessageAttachment($input: DeleteMessageAttachmentInput!) {
    deleteMessageAttachment(input: $input) {
      id
      messageId
      attachmentId
      internal
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment($input: CreateCommentInput!) {
    createComment(input: $input) {
      id
      comment
      internal
      createdAt
      updatedAt
      owner
      atMentions
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      parentComment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment($input: UpdateCommentInput!) {
    updateComment(input: $input) {
      id
      comment
      internal
      createdAt
      updatedAt
      owner
      atMentions
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      parentComment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment($input: DeleteCommentInput!) {
    deleteComment(input: $input) {
      id
      comment
      internal
      createdAt
      updatedAt
      owner
      atMentions
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      parentComment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const createNote = /* GraphQL */ `
  mutation CreateNote($input: CreateNoteInput!) {
    createNote(input: $input) {
      id
      note
      internal
      owner
      createdAt
      updatedAt
      atMentions
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const updateNote = /* GraphQL */ `
  mutation UpdateNote($input: UpdateNoteInput!) {
    updateNote(input: $input) {
      id
      note
      internal
      owner
      createdAt
      updatedAt
      atMentions
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const deleteNote = /* GraphQL */ `
  mutation DeleteNote($input: DeleteNoteInput!) {
    deleteNote(input: $input) {
      id
      note
      internal
      owner
      createdAt
      updatedAt
      atMentions
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const createChange = /* GraphQL */ `
  mutation CreateChange($input: CreateChangeInput!) {
    createChange(input: $input) {
      id
      owner
      createdAt
      updatedAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateChange = /* GraphQL */ `
  mutation UpdateChange($input: UpdateChangeInput!) {
    updateChange(input: $input) {
      id
      owner
      createdAt
      updatedAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteChange = /* GraphQL */ `
  mutation DeleteChange($input: DeleteChangeInput!) {
    deleteChange(input: $input) {
      id
      owner
      createdAt
      updatedAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const createAlert = /* GraphQL */ `
  mutation CreateAlert($input: CreateAlertInput!) {
    createAlert(input: $input) {
      id
      owner
      createdAt
      updatedAt
      type
      subject
      body
      link
      ttl
      level
      status
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const updateAlert = /* GraphQL */ `
  mutation UpdateAlert($input: UpdateAlertInput!) {
    updateAlert(input: $input) {
      id
      owner
      createdAt
      updatedAt
      type
      subject
      body
      link
      ttl
      level
      status
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const deleteAlert = /* GraphQL */ `
  mutation DeleteAlert($input: DeleteAlertInput!) {
    deleteAlert(input: $input) {
      id
      owner
      createdAt
      updatedAt
      type
      subject
      body
      link
      ttl
      level
      status
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
